import React from 'react';
import './Contact.css'


const Contact = () => {

    return (
        <>


<section id="contact" class="contact">

<div class="container" data-aos="fade-up">

  <header class="section-header">
    <h2>Contact</h2>
    <p>Contact Us</p>
  </header>

  <div class="row gy-4">

    <div class="col-lg-6">

      <div class="row gy-4">
        <div class="col-md-6 py-4">
          <div class="info-box">
          <i class="fa-solid fa-location-dot"></i>
            <h3>Address</h3>
            <p>Tema Community 12,<br/>Greater Accra Ghana</p>
          </div>
        </div>
        <div class="col-md-6 py-4">
          <div class="info-box">
          <i class="fa-solid fa-phone"></i>
            <h3>Call Us</h3>
            <p>+233 54 105 7923<br/>+233 27 962 5172</p>
          </div>
        </div>
        <div class="col-md-6 py-4">
          <div class="info-box">
          <i class="fa-regular fa-envelope"></i>
            <h3>Email Us</h3>
            <p>dennisdorny@gmail.com<br/>sengideonsblog@gmail.com</p>
          </div>
        </div>
        <div class="col-md-6 py-4">
          <div class="info-box">
          <i class="fa-regular fa-clock"></i>
            <h3>Open Hours</h3>
            <p>Monday - Friday<br/>8:00AM - 04:00PM</p>
          </div>
        </div>
      </div>

    </div>

    <div class="col-lg-6 py-4">
      <form action="forms/contact.php" method="post" class="php-email-form">
        <div class="row gy-4">

          <div class="col-md-6 py-4">
            <input type="text" name="name" class="form-control" placeholder="Your Name" required />
          </div>

          <div class="col-md-6 py-4">
            <input type="email" class="form-control" name="email" placeholder="Your Email" required />
          </div>

          <div class="col-md-12 py-4">
            <input type="text" class="form-control" name="subject" placeholder="Subject" required />
          </div>

          <div class="col-md-12 py-4">
            <textarea class="form-control" name="message" rows="6" placeholder="Message" required></textarea>
          </div>

          <div class="col-md-12 text-center py-4">
            <div class="loading">Loading</div>
            <div class="error-message"></div>
            <div class="sent-message">Your message has been sent. Thank you!</div>

            <button type="submit">Send Message</button>
          </div>

        </div>
      </form>

    </div>

  </div>

</div>

</section>


        </>
    );

}

export default Contact;